module.exports = [{"name":"mealmixtures","label":"Meal Mixtures","desc":"simple web app solution for meal planning","tech":"materialui,javascript,react,aws,serverless","link":"https://api.url2qr.com/recipes"},{"name":"url2qr","label":"Url 2 QR","desc":"easy convert an url to a QR with  analytics","tech":"materialui,javascript,react,aws,serverless","link":"https://url2qr.com/"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/projects.json
// module id = 479
// module chunks = 0